import { Box, AppBar, Toolbar } from "@mui/material";
import React from "react";
import farmAppLogo from "../../assets/logo/farm-app-logo.png";

const FarmAppBar = () => {
  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={1}
      sx={{ padding: "10px 0" }}
    >
      <Toolbar>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={farmAppLogo}
            alt="Farmapp Logo"
            style={{ height: "60px", width: "auto" }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default FarmAppBar;
